const dashboard = [
  {
    header: 'Apps & Pages',
  },
  {
    title: 'Dashboard',
    icon: 'PieChartIcon',
    enableFeature: true,
    children: [
      {
        title: 'Executive Dashboard',
        route: 'executive-dashboard',
        enableFeature: true,
        hasPermission: 'VIEW_EXECUTIVE_DASHBOARD',
      },
      {
        title: 'Dashboard',
        route: 'dashboard',
        enableFeature: true,
      },
      {
        title: 'Home',
        route: 'home',
        enableFeature: true,
      },
    ],
  },
]
export default dashboard
